/* Registers the Live Mode service worker.
 * Gated to production builds and to pages that actually load inside /live/*,
 * so Plan Mode users never pick up a service worker and always get fresh
 * deploys.
 */

export function registerLiveServiceWorker() {
  if (typeof window === 'undefined') return;
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;
  if (!window.location.pathname.startsWith('/live')) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/live-sw.js', { scope: '/live/' })
      .catch((err) => {
        console.warn('[live-sw] registration failed:', err);
      });
  });
}
